export default __webpack_public_path__ + "static/media/deema.aa4123b9.png";